import * as _ from "lodash";
import {fromJS, List} from 'immutable';

import {
  SITES_REQUEST, SITES_SUCCESS, SITES_UPDATE_REQUEST, SITES_CHANGES_SAVING, SITES_CHANGES_SAVED,
  SITES_CANCEL_CHANGES
}
  from '../../constants/actionTypes';

import {ActionTypes} from "./SitesActions";

const initialState = {
  records: List(),
  totalPages: 0,
  focusedSiteIndex: null,
  searchKeyword: '',
  sortKeyword: '',
  sortOrder: '',
  loading: false,
  statusUpdateSuccess: false
};

function handleSiteSuccess(state, data) {
  _.forEach(data.rows, s => {
    s.original = _.cloneDeep(s);
    s.changed = false;
  });

  return {...state, records: fromJS(data.rows), page: data.page, totalPages: data.totalPages};
}

function handleSiteUpdate(state, {value, propName, site}) {
  let {records} = state;
  let s = records.findIndex(r => r.get('fabricator_id') === site.fabricator_id && r.get('site_id') === site.site_id);
  records = records.setIn([s, propName], value);
  records = records.setIn([s, 'changed'],
    records.getIn([s, 'original', 'subDomain']) !== records.getIn([s, 'subDomain']) ||
    records.getIn([s, 'original', 'enabled']) !== records.getIn([s, 'enabled']) ||
    records.getIn([s, 'original', 'kitchenVisualizerEnabled']) !== records.getIn([s, 'kitchenVisualizerEnabled'])
  );

  return {...state, records};
}

function handleCancelChanges(state) {
  let {records} = state;
  records = records.map(r => {
    if (r.get('changed')) {
      r = r.set('changed', false);
      r = r.set('subDomain', r.getIn(['original', 'subDomain']));
      r = r.set('enabled', r.getIn(['original', 'enabled']));
      r = r.set('kitchenVisualizerEnabled', r.getIn(['original', 'kitchenVisualizerEnabled']));
    }
    return r;
  });

  return {...state, records};
}

function handleSitesSaved(state, data) {
  let {records} = state;
  _.forEach(data, site => {
    let idx = records.findIndex(r => +r.get('fabricator_id') === site.fabricator_id && r.get('subDomain') === site.subDomain);
    records = records.set(idx, fromJS(site));
  });

  records = records.map(r => {
    r = r.set('changed', false);
    r = r.set('original', fromJS(_.cloneDeep(r.toJS())));
    return r;
  });

  return {...state, records};
}

export function getChangedSites(state) {
  return _.filter(state.records.toJS(), {'changed': true})
    .map(r => {
      delete r.original;
      return r;
    });
}

export default function sites(state = initialState, action) {
  switch (action.type) {
    case SITES_REQUEST:
      return {
        ...state,
        searchKeyword: action.searchKeyword,
        loading: true,
        statusUpdateSuccess: false
      };
    case ActionTypes.DELETE_SITE_REQUEST:
      return {...state, loading: true, statusUpdateSuccess: false};
    case SITES_SUCCESS:
      return handleSiteSuccess(state, action.payload);
    case SITES_UPDATE_REQUEST:
      return handleSiteUpdate(state, action.payload);
    case SITES_CHANGES_SAVED:
      return handleSitesSaved(state, action.payload);
    case SITES_CHANGES_SAVING:
      return {...state, statusUpdateSuccess: false};
    case SITES_CANCEL_CHANGES:
      return handleCancelChanges(state);
    case ActionTypes.DELETE_SITE_RESPONSE:
      return {...state, statusUpdateSuccess: true};
    default:
      return state;
  }
}
